import { render } from "./NavigationComponent.vue?vue&type=template&id=5eb76e30&ts=true"
import script from "./NavigationComponent.vue?vue&type=script&lang=ts"
export * from "./NavigationComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__